import { useState } from "react";
import { Users } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/PageHeader";
import { AddButton, SearchInput, ListCard, Empty } from "@/components/Bits";
import { ClienteFormDialog } from "@/components/ClienteFormDialog";
import UsersPage from "@/pages/UsersPage";
import { BloqueiosTab } from "@/components/BloqueiosTab";
import { useFetch } from "@/lib/useFetch";

const CLIENT_ROLES = ["cliente"];

export default function ClientesPage() {
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const { data, reload } = useFetch("/clientes", { q: q || undefined });

  return (
    <div data-testid="clientes-page">
      <PageHeader eyebrow="Cadastros" title="Clientes" subtitle="Produtores, suas fazendas e contas de acesso ao aplicativo." />
      <Tabs defaultValue="cadastros">
        <TabsList className="h-14 p-1 rounded-xl bg-white border border-[#E2DDD3] mb-5 w-full sm:w-auto">
          <TabsTrigger value="cadastros" className="h-12 px-5 rounded-lg flex-1 data-[state=active]:bg-[#1E4D2B] data-[state=active]:text-white" data-testid="tab-cadastros">Cadastros</TabsTrigger>
          <TabsTrigger value="bloqueios" className="h-12 px-5 rounded-lg flex-1 data-[state=active]:bg-[#B05A40] data-[state=active]:text-white" data-testid="tab-bloqueios">Bloqueios</TabsTrigger>
          <TabsTrigger value="contas" className="h-12 px-5 rounded-lg flex-1 data-[state=active]:bg-[#1E4D2B] data-[state=active]:text-white" data-testid="tab-contas">Contas de acesso</TabsTrigger>
        </TabsList>
        <TabsContent value="cadastros">
          <div className="flex gap-3 mb-5">
            <SearchInput value={q} onChange={setQ} placeholder="Buscar nome, CPF/CNPJ, e-mail" testId="cliente-search-input" />
            <AddButton onClick={() => setOpen(true)} data-testid="cliente-add-button">Novo</AddButton>
          </div>
          {data?.length === 0 && <Empty testId="cliente-list-empty">Nenhum cliente cadastrado.</Empty>}
          <div className="space-y-3" data-testid="cliente-list">
            {(data || []).map((c) => (
              <ListCard key={c.cliente_id} to={`/clientes/${c.cliente_id}`} icon={Users} testId={`cliente-card-${c.cliente_id}`}
                title={c.nome} subtitle={[c.documento, c.whatsapp || c.telefone].filter(Boolean).join(" · ") || c.email}
                meta={`${c.total_fazendas} fazenda(s)${c.bloqueado ? " · BLOQUEADO" : c.user_id ? " · com acesso ao app" : ""}`} />
            ))}
          </div>
        </TabsContent>
        <TabsContent value="bloqueios"><BloqueiosTab /></TabsContent>
        <TabsContent value="contas">
          <UsersPage embedded testId="clientes-contas" roles={CLIENT_ROLES} />
        </TabsContent>
      </Tabs>
      <ClienteFormDialog open={open} onOpenChange={setOpen} onSaved={reload} />
    </div>
  );
}
